// extracted by mini-css-extract-plugin
export default {"container":"styles_container__JIQUK","searchIcon":"styles_searchIcon__tWnWQ","searchInput":"styles_searchInput__rZZmv","searchInputMobile":"styles_searchInputMobile__YNxb5"};